export const PLAYER_ADD = 'PLAYER_ADD';
export const PLAYER_UPDATE = 'PLAYER_UPDATE';
export const ROUND_SCOPA_ADD = 'ROUND_SCOPA_ADD';
export const ROUND_SCOPA_POINT_ADD = 'ROUND_SCOPA_POINT_ADD';
export const ROUND_SCOPA_RESET = 'ROUND_SCOPA_RESET';
export const FIRST_PLAYER_ID_TO_SERVE_SET = 'FIRST_PLAYER_ID_TO_SERVE_SET';

export const ROUND_WIST_ADD = 'ROUND_WIST_ADD';
export const ROUND_WIST_BETS_INCREASE = 'ROUND_WIST_BETS_INCREASE';
export const ROUND_WIST_BETS_DECREASE = 'ROUND_WIST_BETS_DECREASE';
export const ROUND_WIST_DONES_INIT = 'ROUND_WIST_DONES_INIT';
export const ROUND_WIST_DONES_INCREASE = 'ROUND_WIST_DONES_INCREASE';
export const ROUND_WIST_DONES_DECREASE = 'ROUND_WIST_DONES_DECREASE';
export const ROUND_WIST_ACTIVE_STEP_SWITCH = 'ROUND_WIST_ACTIVE_STEP_SWITCH';

export const ROUND_MTG_ADD = 'ROUND_MTG_ADD';
export const ROUND_MTG_LIFE_INCREASE = 'ROUND_MTG_LIFE_INCREASE';
export const ROUND_MTG_LIFE_DECREASE = 'ROUND_MTG_LIFE_DECREASE';
export const ROUND_MTG_LIFE_SET = 'ROUND_MTG_LIFE_SET';
export const ROUND_MTG_RESET = 'ROUND_MTG_RESET';
